<template>
    <div>
        <ul
            v-if="mode=='tabs'"
            id="myTab"
            class="nav nav-tabs exec-tabs"
            role="tablist"
        >
            <li v-for="status in states" :key="`status-${status.value}`" class="nav-item">
                <a
                    :class="{'nav-link': true, active: currentTab.name == status.name}"
                    :href="`#${status.name}`"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                    @click.prevent="currentTab=status"
                >
                    <i v-if="status.iconClass" :class="status.iconClass" />
                    {{ status.title || status.name }}
                </a>
            </li>
        </ul>

        <multiselect
            v-else
            v-model="currentTab"
            :show-labels="false"
            :options="states"
            :searchable="false"
            placeholder="Select an option"
            class="w-100"
            track-by="name"
            label="title"
        />
    </div>
</template>

<script>
export default {
    props: {
        states: {
            type: Array,
            default() {
                return []
            },
            required: true
        },
        searchOptions: {
            type: Object,
            default() {
                return {}
            }
        },
        styleOptions: {
            type: Object,
            default() {
                return {
                    textColor: "",
                    activeColor: "",
                    borderHeight: "",
                    borderActiveColor: ""
                }
            }
        },
        mode: {
            type: String,
            default: "select"
        },
        historyMode: {
            type: Boolean,
            default: true
        },
        textColor: {
            type: String,
            default: "#333333"
        },
        activeColor: {
            type: String,
            default: "#203469"
        },
        borderActiveColor: {
            type: String,
            default: ""
        },
        borderHeight: {
            type: String,
            default: "2px"
        }
    },
    data() {
        return {
            isMounted: false,
            currentTab: {}
        }
    },
    watch: {
        "$route.query": {
            handler(params) {
                if (params && Object.keys(params).length) {
                    const filters = Object.entries(params).filter(props => props[0].includes("filter"));
                    if (filters && filters.length) {
                        // eslint-disable-next-line no-unused-vars
                        const [_, field] = filters[0][0].split(".");
                        const currentTab = this.states.find((tab) => {
                            return tab.field == field && (tab.value == filters[0][1] || tab.name == filters[0][1])
                        })

                        if (currentTab) {
                            this.currentTab = currentTab
                        }
                    }
                    return
                }

            },
            immediate: true,
            deep: true
        },

        currentTab:{
            handler(currentTab, oldTab) {
                if (currentTab) {
                    this.searchOptions.fixedFilters = {
                        [currentTab.field] : currentTab.value || ""
                    };
                    if (!oldTab || currentTab.value != oldTab.value) {
                        if (this.historyMode) {
                            this.$router.replace({
                                name: this.$route.name,
                                params: { resource: this.$route.params.resource },
                                query: {
                                    [`filter.${currentTab.field}`]: `${currentTab.name}`
                                }
                            })
                        }

                        this.isMounted && this.$emit("selected", currentTab)
                    }
                }
            },
            immediate: true
        },
        states: {
            handler() {
                this.currentTab = this.currentTab.name && this.states.find(item => item.name == this.currentTab.name) ? this.currentTab : this.states[0]
            },
            immediate: true,
            deep: true
        },
        styleOptions: {
            handler() {
                this.setStyles();
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.isMounted = true;
        this.$emit("selected", this.currentTab)
    },
    methods: {
        setStyles() {
            const styles = document.documentElement.style;
            const activeColor = this.styleOptions.activeColor || this.activeColor;
            const borderActiveColor = this.styleOptions.borderActiveColor || this.borderActiveColor || activeColor;
            const borderHeight = this.styleOptions.borderHeight || this.borderHeight;

            styles.setProperty("--tab-color", this.styleOptions.textColor || this.textColor)
            styles.setProperty("--tab-color-border-active", borderActiveColor)
            styles.setProperty("--tab-color-active", activeColor)
            styles.setProperty("--tab-bar-height", borderHeight)
        },

        setTab(tabName) {
            this.currentTab = this.states.find(item => item.name == tabName);
        }
    }
}
</script>

<style lang="scss">
    .nav.nav-tabs.exec-tabs {
        display: flex;
        flex-direction: row;
        margin-bottom: 15px;
        position: relative;
        border: none;

        &::after {
            position: absolute;
            content: '';
            height: 2px;
            width: 100%;
            background: var(--execlist-color-gray2);
            z-index: -1;
            bottom: -1px;
        }

        .nav-item {
            background-color: transparent;
            border: none;

            a {
                color: var(--tab-color);
            }
        }

        .nav-link {
            border: none;
            text-transform: none;
            font-weight: bolder;
            transition: all ease .3s;
            color: var(--tab-color);
            border-bottom: 2px solid transparent;
        }

        .nav-link.active {
            background-color: transparent;
            border: none;
            border-bottom: var(--tab-bar-height) solid var(--tab-color-border-active);
            color: var(--tab-color-active);
        }
    }

</style>
